import mixpanel, { Dict } from 'mixpanel-browser';
import { useCallback, useEffect } from 'react';
import { useTokens } from '../store/auth/useTokens';

export const useMixedPanel = () => {
  const { userInfo } = useTokens.getState();

  const userName = userInfo?.username;

  const mixPanelToken = process.env.NEXT_PUBLIC_INTRADAY_MIX_PANEL_TOKEN;

  useEffect(() => {
    if (mixPanelToken) {
      mixpanel.init(mixPanelToken, {
        persistence: 'localStorage',
      });
    }
  }, [mixPanelToken]);

  useEffect(() => {
    if (userName && mixPanelToken) {
      mixpanel.identify(userName);
      mixpanel.people.set({
        $distinct_id: userName,
        $broker: userInfo?.broker,
      });
    }
  }, [mixPanelToken, userName, userInfo]);

  const trackEvent = useCallback(
    (name: string, props?: Dict) => {
      if (mixPanelToken) {
        mixpanel.track(name, {
          ...props,
          ...(userInfo?.clientType && { clientType: userInfo?.clientType }),
        });
      }
    },
    [mixPanelToken, userInfo?.clientType]
  );

  const trackPageView = useCallback(
    (page: string) => {
      if (mixPanelToken) {
        mixpanel.track_pageview({ page });
      }
    },
    [mixPanelToken]
  );

  return {
    trackEvent,
    trackPageView,
  };
};
